import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {
  NgModule,
  ApplicationRef
} from '@angular/core';
import {
  removeNgStyles,
  createNewHosts,
  createInputTransfer
} from '@angularclass/hmr';
import {
  RouterModule,
  PreloadAllModules
} from '@angular/router';

/*
 * Platform and Environment providers/directives/pipes
 */
import { ENV_PROVIDERS } from './environment';
import { ROUTES } from './app.routes';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';
import { AboutComponent } from './about';
import { NoContentComponent } from './no-content';
import { ReservationComponent } from './admin/reservation/reservation.component';

import '../styles/styles.scss';
import '../styles/headings.css';
import { ResourceModule } from 'ng2-resource-rest';
import { CalendarComponent } from './calendar/calendar.component';

import { DomHandler } from 'primeng/components/dom/domhandler';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { CalendarItemComponent } from './calendar/calendar-item.component';
import { CustomerNamePipe } from './pipe/customer-name.pipe';
import { VatPipe } from './pipe/vat.pipe';
import { MoneyPipe } from './pipe/money.pipe';
import { ErrorDirective } from './directive/error.directive';
import { LabelPipe } from './pipe/label.pipe';
import { InvoiceComponent } from './invoice/invoice.component';
import { OrderComponent } from './order/order.component';
import { BigboolsComponent } from './bigbools/bigbools.component';
import { ContactComponent } from './contact/contact.component';
import { FinanceComponent } from './admin/finance/finance.component';
import { FrontpageComponent } from './frontpage/frontpage.component';
import { LocalStorageModule } from 'angular-2-local-storage';
import {
  CalendarModule,
} from 'primeng/components/calendar/calendar';
import {
  DialogModule,
} from 'primeng/components/dialog/dialog';
import {
  GrowlModule,
} from 'primeng/components/growl/growl';
import {
  TooltipModule,
} from 'primeng/components/tooltip/tooltip';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { ReCaptchaModule } from 'angular2-recaptcha';
import { OrderByPipe } from './pipe/order-by.pipe';
import { UploadComponent } from './admin/upload/upload.component';
import { FileSelectDirective } from 'ng2-file-upload';
import { PreviewComponent } from './admin/preview/preview.component';

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState,
  DomHandler
];

type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    AboutComponent,
    NoContentComponent,
    ReservationComponent,
    InvoiceComponent,
    CalendarComponent,
    DatepickerComponent,
    CalendarItemComponent,
    OrderComponent,
    BigboolsComponent,
    FrontpageComponent,
    ContactComponent,
    FinanceComponent,
    UploadComponent,
    PreviewComponent,
    CustomerNamePipe,
    MoneyPipe,
    VatPipe,
    LabelPipe,
    OrderByPipe,
    ErrorDirective,
    FileSelectDirective
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    FormsModule,
    HttpModule,
    RouterModule.forRoot(ROUTES, { useHash: false, preloadingStrategy: PreloadAllModules }),
    ResourceModule.forRoot(),
    CalendarModule,
    DialogModule,
    GrowlModule,
    TooltipModule,
    BrowserModule,
    NoopAnimationsModule,
    LocalStorageModule.withConfig({
      prefix: 'my-app',
      storageType: 'localStorage'
    }),
    ReCaptchaModule
  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    ENV_PROVIDERS,
    APP_PROVIDERS
  ]
})
export class AppModule {

  constructor(
    public appRef: ApplicationRef,
    public appState: AppState
  ) {}

  public hmrOnInit(store: StoreType) {
    if (!store || !store.state) {
      return;
    }
    console.log('HMR store', JSON.stringify(store, null, 2));
    // set state
    this.appState._state = store.state;
    // set input values
    if ('restoreInputValues' in store) {
      let restoreInputValues = store.restoreInputValues;
      setTimeout(restoreInputValues);
    }

    this.appRef.tick();
    delete store.state;
    delete store.restoreInputValues;
  }

  public hmrOnDestroy(store: StoreType) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    // save state
    const state = this.appState._state;
    store.state = state;
    // recreate root elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // save input values
    store.restoreInputValues  = createInputTransfer();
    // remove styles
    removeNgStyles();
  }

  public hmrAfterDestroy(store: StoreType) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/app.module.ts